<header>
  <ng-container *ngIf="isAuthenticated$ | async">
    <div class="flex flex-wrap align-items-center justify-content-between">
      <div class="flex flex-wrap align-items-center justify-content-start">
        <div
          class="flex flex-wrap justify-content-start align-items-center mr-4"
        >
          <app-agility-button
            id="header-logo-button"
            ariaLabel="Agility Logo"
            buttonType="button"
            text="true"
            routerLink="/secure/dashboard/landing"
            data-testid="header-logo-button"
            [trackEventName]="analyticsEvents.BUTTON_CLICK"
            [trackParams]="headerLogoButtonClickParams"
            (clicked)="turnOffMobileNav()"
          >
            <img [src]="logoUrl" alt="Agility" class="logo" />
          </app-agility-button>
          <p-button
            *ngIf="!isLargeScreen"
            id="hamBurgerMenuIcon"
            (keydown.esc)="onEscKeyDown()"
            (click)="toggleMobileNav()"
            pRipple
            [icon]="isMobileNavTurnedOn ? 'pi pi-times' : 'pi pi-bars'"
            class="flex-order-0 my-2"
            aria-label="'header.nav.ariaLabels.menuIcon' | translate"
            aria-describedby="mobileAppNav"
            data-testid="header-hamburger-menu-button"
          ></p-button>
        </div>
        <app-navigation *ngIf="isLargeScreen"></app-navigation>

        <app-mobile-navigation
          *ngIf="!isLargeScreen"
          [show-mobile-nav]="isMobileNavTurnedOn"
        ></app-mobile-navigation>
      </div>
      <div class="flex flex-wrap align-items-center">
        <nav>
          <ul class="nav flex justify-content-center">
            <li *ngIf="userType === tenantUser && isIntelligenceEnabled">
              <div
                class="agility-intelligence-wrapper"
                [class.permission-restricted]="
                  !hasAgilityIntelligencePermission
                "
                [pTooltip]="
                  hasAgilityIntelligencePermission
                    ? ('header.nav.tooltips.agilityIntelligence' | translate)
                    : permissionService.tooltip
                "
                tooltipPosition="bottom"
              >
                <button
                  id="powerBiButton"
                  pButton
                  pRipple
                  type="button"
                  icon="pi"
                  class="p-button-rounded p-button-help my-2 agility-intelligence-button"
                  [disabled]="!hasAgilityIntelligencePermission"
                  [attr.aria-disabled]="!hasAgilityIntelligencePermission"
                  aria-label="'header.nav.ariaLabels.powerBi' | translate"
                  (click)="onAgilityIntelligenceClick()"
                  data-testid="header-powerbi-button"
                >
                  <img
                    alt="power-bi icon"
                    class="custom-power-bi-icon"
                    src="../../../../assets/images/powerbi-dark.svg"
                  />
                </button>
              </div>
            </li>
            <li>
              <button
                (click)="search.toggle($event)"
                pButton
                pRipple
                type="button"
                icon="pi pi-search"
                class="p-button-rounded p-button-help ml-2 my-2"
                aria-label="'header.nav.ariaLabels.searchIcon' | translate"
                [pTooltip]="'header.nav.tooltips.loanSearch' | translate"
                tooltipPosition="bottom"
                data-testid="header-search-button"
              ></button>
            </li>
            <!-- <li (click)="turnOffMobileNav()">
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-bell"
                  class="p-button-rounded p-button-help ml-2 my-2"
                  aria-label="'header.nav.ariaLabels.notificationsIcon' | translate"
                ></button>
              </li> -->
            <li>
              <button
                (click)="menu.toggle($event)"
                pButton
                pRipple
                type="button"
                icon="pi pi-user"
                class="p-button-rounded p-button-help ml-2 my-2"
                aria-label="'header.nav.ariaLabels.profileIcon' | translate"
                [pTooltip]="'header.nav.tooltips.userProfile' | translate"
                tooltipPosition="bottom"
                data-testid="header-user-profile-button"
              ></button>
            </li>
            <p-menu
              #menu
              class="user-menu"
              [model]="items"
              [popup]="true"
              appendTo="body"
              data-testid="header-user-menu"
            ></p-menu>
            <p-popover
              #search
              appendTo="body"
              data-testid="header-search-panel"
            >
              <ng-template #content>
                <app-global-loan-search
                  (closePopover)="closePopover(search)"
                  [recentlyViewedLoanSize]="recentlyViewedLoanSize"
                >
                </app-global-loan-search>
              </ng-template>
            </p-popover>
          </ul>
        </nav>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="(isAuthenticated$ | async) === false">
    <div class="flex flex-wrap align-items-center justify-content-between">
      <div class="flex flex-wrap justify-content-start align-items-center">
        <h1
          class="flex-order-1"
          [class.ml-1]="!isLargeScreen"
          (click)="turnOffMobileNav()"
        >
          <a
            class="flex flex-wrap align-items-center no-underline"
            routerLink="/public"
            >{{ agilityAppTitle }}</a
          >
        </h1>
      </div>
    </div>
  </ng-container>
</header>
